/**
 * @fileoverview PATCH handler for the "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersShopifyAppGroupIdBridgesBridgeIdCacheKeys } from "./constants";
import type {
  PatchAlloysPartnersShopifyAppGroupIdBridgesBridgeIdProps,
  PatchAlloysPartnersShopifyAppGroupIdBridgesBridgeIdResult,
} from "./types";

export const patchAlloysPartnersShopifyAppGroupIdBridgesBridgeId = reactQueryMutationAdapter(
  alloysPartnersShopifyAppGroupIdBridgesBridgeIdCacheKeys,
  ({
    appGroupId,
    bridgeId,
    enabledUserEvents,
    externalIdType,
    customIdEndpoint,
    enabledInBrowserMessaging,
    enabledBanners,
    emailOptIn,
    additionalEmailSubscriptionGroupIds,
    smsOptIn,
    smsSubscriptionGroup,
    additionalSmsSubscriptionGroupIds,
    routeSmsConsentByCountry,
    smsDoubleOptIn,
    defaultEmailSubscriptionGroupName,
    defaultEmailSubscriptionGroupId,
    defaultMarket,
    routeEmailConsentByCountry,
    historicalBackfillOptIn,
    directIntegrationSelected,
    webAppId,
    thirdPartyTagManager,
    userTrackingBehavior,
    catalogOptIn,
    catalogItemIdType,
    catalogIncludeOnlyActiveProducts,
    syncProductTags,
    selectedProductTags,
    syncProductMetafields,
    selectedProductMetafields,
    syncProductCollections,
    selectedCollectionIds,
    selectedCollections,
    selectedMarkets,
    shopifyBackupRegionId,
    shopifyBackupRegionName,
    shopifyDefaultLocale,
    sdkVersion,
    segmentIds,
    allowResync,
    pauseSegmentId,
    resumeSegmentId,
    segmentSyncPaused,
  }: PatchAlloysPartnersShopifyAppGroupIdBridgesBridgeIdProps): Promise<PatchAlloysPartnersShopifyAppGroupIdBridgesBridgeIdResult> => {
    return fetch(
      `/alloys/partners/shopify/${appGroupId}/bridges/${bridgeId}`,
      "PATCH",
      {
        enabled_user_events: enabledUserEvents,
        external_id_type: externalIdType,
        custom_id_endpoint: customIdEndpoint,
        enabled_in_browser_messaging: enabledInBrowserMessaging,
        enabled_banners: enabledBanners,
        email_opt_in: emailOptIn,
        additional_email_subscription_group_ids: additionalEmailSubscriptionGroupIds,
        sms_opt_in: smsOptIn,
        sms_subscription_group: smsSubscriptionGroup,
        additional_sms_subscription_group_ids: additionalSmsSubscriptionGroupIds,
        route_sms_consent_by_country: routeSmsConsentByCountry,
        sms_double_opt_in: smsDoubleOptIn,
        default_email_subscription_group_name: defaultEmailSubscriptionGroupName,
        default_email_subscription_group_id: defaultEmailSubscriptionGroupId,
        default_market: defaultMarket,
        route_email_consent_by_country: routeEmailConsentByCountry,
        historical_backfill_opt_in: historicalBackfillOptIn,
        direct_integration_selected: directIntegrationSelected,
        web_app_id: webAppId,
        third_party_tag_manager: thirdPartyTagManager,
        user_tracking_behavior: userTrackingBehavior,
        catalog_opt_in: catalogOptIn,
        catalog_item_id_type: catalogItemIdType,
        catalog_include_only_active_products: catalogIncludeOnlyActiveProducts,
        sync_product_tags: syncProductTags,
        selected_product_tags: selectedProductTags,
        sync_product_metafields: syncProductMetafields,
        selected_product_metafields: selectedProductMetafields,
        sync_product_collections: syncProductCollections,
        selected_collection_ids: selectedCollectionIds,
        selected_collections: selectedCollections,
        selected_markets: selectedMarkets,
        shopify_backup_region_id: shopifyBackupRegionId,
        shopify_backup_region_name: shopifyBackupRegionName,
        shopify_default_locale: shopifyDefaultLocale,
        sdk_version: sdkVersion,
        segment_ids: segmentIds,
        allow_resync: allowResync,
        pause_segment_id: pauseSegmentId,
        resume_segment_id: resumeSegmentId,
        segment_sync_paused: segmentSyncPaused,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
